import { createClient } from "@smfa/utils";
const baseUrl = process.env?.API_URL || process.env?.REACT_APP_BACKEND_URL;

const axios = createClient({ baseUrl, isAdminSite: true });

export const getFiestaBanner = (data) =>
  axios.get("/fiestabanners", data ? { params: data } : {});

export const updateFiestaBanner = (data) =>
  axios.post("/fiestabannerupdate", data);

export const getFiestaIntro = (data) =>
  axios.get("/fiestaintro", data ? { params: data } : {});

export const updateFiestaIntro = (data) =>
  axios.post("/fiestaintroupdate", data);

export const getFiestaSession = (data) =>
  axios.post("/fiestasessiondata", data);

export const addEditFiestaSession = (data) =>
  axios.post("/add_edit_fiesta", data);

export const deleteFiestaSession = (data) =>
  axios.post("/delete_fiestasession", data);
